import React, { Component } from "react";
import { Row, Col, Grid } from "react-bootstrap";
import { Message, Button, Form, Icon } from "semantic-ui-react";

import { Helmet } from "react-helmet";

import Sidebar from "../../Sidebar/Sidebar";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";

import BannerRectangleLarge from "../../Banner/BannerRectangleLarge";
import BannerRectangle from "../../Banner/BannerRectangle";

import { translate, getLanguage } from "../../Translation/Translation";

import { SingleDatePicker } from "react-dates";
import Recaptcha from "react-recaptcha";
import Modal from "../../Modal/Modal";
import InnerModalGDPR from "../../InnerModal/InnerModalGDPR";
import { FETCH_URL } from "../../../utilities";

const styles = {
  paragraph: {
    lineHeight: "48px",
    color: "#293f54",
    fontSize: 28,
    padding: "20px 0px",
  },
};

class Advertise extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: null,
      endDate: null,
      disabled: true,
      isLoading: false,
      completed: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleModalClick = this.handleModalClick.bind(this);
  }

  handleModalClick(event) {
    event.preventDefault();
    this.setState({
      showModal: !this.state.showModal,
      checkbox1: false,
      checkbox2: false,
      checkbox3: false,
      checkbox4: false,
    });
  }

  showGDPRModal = () => {
    const { fullname, telephone, email, address } = this.state;

    console.log(this.state);
    if (!fullname || !telephone || !email || !address) {
      window.scrollTo(0, 700);
      return;
    }

    this.setState({ isLoading: true, showModal: true });
  };

  reportCheckboxChanged = (checkboxName) => {
    console.log(this.state);
    this.setState({
      [checkboxName]: !this.state[checkboxName],
    });
  };

  submitForm = () => {
    this.setState({ isLoading: true });

    const START_DATE =
      this.state.startDate && this.state.startDate.format("DD-MM-YYYY");
    const END_DATE =
      this.state.endDate && this.state.endDate.format("DD-MM-YYYY");
    const PERIOD = `${START_DATE}-${END_DATE}`;

    let IS_MORNING = false;
    if (this.state.morning) {
      IS_MORNING = true;
    }
    let IS_AFTERNOON = false;
    if (this.state.afternoon) {
      IS_AFTERNOON = true;
    }

    let CONTACT = "ALL_DAY";
    if (IS_MORNING && !IS_AFTERNOON) {
      CONTACT = "MORNING";
    } else if (!IS_MORNING && IS_AFTERNOON) {
      CONTACT = "AFTERNOON";
    } else if (!IS_AFTERNOON && !IS_MORNING) {
      CONTACT = "NEVER";
    }

    return fetch(
      `${FETCH_URL}/mail.php?fullname=${this.state.fullname}&address=${this.state.address}&company=${this.state.company}&email=${this.state.email}&contact=${CONTACT}&period=${PERIOD}&telephone=${this.state.telephone}&notes=${this.state.notes}&banner=${this.state.banner}&checkbox1=${this.state.checkbox1}&checkbox2=${this.state.checkbox2}&checkbox3=${this.state.checkbox3}&checkbox4=${this.state.checkbox4}`,
      {
        method: "GET",
      }
    )
      .then((response) => {
        this.setState({
          isLoading: false,
          completed: true,
          disabled: true,
          showModal: false,
        });
        window.scrollTo(0, 500);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  needBanner = (need) => {
    this.setState({ banner: need });
  };

  handleChange(event) {
    if (event.target.name === "morning" || event.target.name === "afternoon") {
      this.setState({ [event.target.name]: event.target.checked });
    } else {
      this.setState({ [event.target.name]: event.target.value });
    }
  }

  // specifying your onload callback function
  callback = () => {
    // console.log('Done!!!!');
  };

  // specifying verify callback function
  verifyCallback = (response) => {
    this.setState({ disabled: false });
  };

  render() {
    const width = window.innerWidth;
    let orientation = "horizontal";
    if (width < 768) {
      orientation = "vertical";
    }

    return (
      <div>
        <Grid fluid className="no-padding">
          <Helmet>
            <title>Advertise With Us | Openseas</title>
            <meta
              name="description"
              content="Η Openseas προσφέρει τη δυνατότητα σε ταξιδιωτικούς πράκτορες από την Ελλάδα και το εξωτερικό να διαφημιστούν στην ιστοσελίδα της. Μη χάσετε την ευκαιρία να διαφημιστείτε σε μία ιστοσελίδα με μισό εκατομμύριο χρήστες το χρόνο."
            />
          </Helmet>
          <Modal
            open={this.state.showModal}
            clickOutSide={this.handleModalClick}
          >
            <InnerModalGDPR
              clickHandler={this.handleModalClick}
              submitForm={this.submitForm}
              reportCheckboxChanged={this.reportCheckboxChanged}
              checkbox1={this.state.checkbox1}
              checkbox2={this.state.checkbox2}
              checkbox3={this.state.checkbox3}
              checkbox4={this.state.checkbox4}
            />
          </Modal>
          <Row style={{ margin: "0px" }}>
            <Col style={{ margin: "0px" }}>
              <Header data={this.props} />
            </Col>
          </Row>
          <Row style={{ margin: "0px" }}>
            <div className="OSPageContainer">
              <div className="OSPageContent">
                <p style={styles.paragraph}>
                  {translate(
                    getLanguage(),
                    "Advertise with us and promote your business activity to thousands of users visiting OpenSeas daily."
                  )}
                </p>
                {this.state.isLoading && (
                  <Message icon>
                    <Icon name="circle notched" loading />
                    <Message.Content>
                      <Message.Header>Loading...</Message.Header>
                      We are processing your request.
                    </Message.Content>
                  </Message>
                )}
                {this.state.completed && (
                  <Message
                    success
                    header="Success"
                    content="We received your application. "
                  />
                )}

                <Form onSubmit={() => {}}>
                  <div className="contactLabel" style={{ margin: "0px" }}>
                    {translate(getLanguage(), "Contact Information")}
                  </div>
                  <Form.Field required>
                    <label>{translate(getLanguage(), "Name/Surname")}</label>
                    <input
                      required
                      placeholder={translate(getLanguage(), "Name/Surname")}
                      name="fullname"
                      onChange={this.handleChange}
                    />
                  </Form.Field>
                  <Form.Group widths="equal">
                    <Form.Input
                      name="email"
                      onChange={this.handleChange}
                      required
                      fluid
                      label={translate(getLanguage(), "E-Mail Address")}
                      placeholder={translate(getLanguage(), "E-Mail Address")}
                    />
                    <Form.Input
                      name="telephone"
                      onChange={this.handleChange}
                      required
                      fluid
                      label={translate(getLanguage(), "Contact Telephone")}
                      placeholder={translate(
                        getLanguage(),
                        "Contact Telephone (+##)-###-###-####"
                      )}
                    />
                  </Form.Group>
                  <Form.Field required>
                    <label>{translate(getLanguage(), "Address")}</label>
                    <input
                      required
                      placeholder={translate(getLanguage(), "Address")}
                      onChange={this.handleChange}
                      name="address"
                    />
                  </Form.Field>
                  <Form.Field>
                    <label>{translate(getLanguage(), "Company type")}</label>
                    <input
                      name="company"
                      onChange={this.handleChange}
                      placeholder={translate(
                        getLanguage(),
                        "Company type (e.g Travel Agency)"
                      )}
                    />
                  </Form.Field>
                  <div className="contactLabel" style={{ margin: "0px" }}>
                    {translate(getLanguage(), "Advertisement valid period")}
                  </div>
                  <Form.Group widths="equal">
                    <Form.Field>
                      <label>{translate(getLanguage(), "Date from")}</label>

                      <div className="singleDay">
                        <SingleDatePicker
                          id="from"
                          date={this.state.startDate} // momentPropTypes.momentObj or null,
                          onDateChange={(startDate) =>
                            this.setState({ startDate })
                          } // PropTypes.func.isRequired
                          focused={this.state.focusedStart} // PropTypes.bool
                          readOnly
                          onFocusChange={({ focused }) =>
                            this.setState({ focusedStart: focused })
                          } // PropTypes.func.isRequired
                          orientation={orientation}
                          placeholder={translate(getLanguage(), "Date from")}
                          phrases={{
                            closeDatePicker: "Close",
                            clearDates: "Clear",
                          }}
                          displayFormat="DD/MM/YYYY"
                        />
                      </div>
                    </Form.Field>
                    <Form.Field>
                      <label>{translate(getLanguage(), "Date to")}</label>

                      <div className="singleDay">
                        <SingleDatePicker
                          id="to"
                          date={
                            this.state.endDate != null
                              ? this.state.endDate
                              : this.state.startDate
                          }
                          onDateChange={(endDate) => this.setState({ endDate })} // PropTypes.func.isRequired
                          focused={this.state.focusedEnd} // PropTypes.bool
                          readOnly
                          onFocusChange={({ focused }) =>
                            this.setState({ focusedEnd: focused })
                          } // PropTypes.func.isRequired
                          orientation={orientation}
                          placeholder={translate(getLanguage(), "Date to")}
                          phrases={{
                            closeDatePicker: "Close",
                            clearDates: "Clear",
                          }}
                          displayFormat="DD/MM/YYYY"
                          isOutsideRange={(day) =>
                            day.isBefore(this.state.startDate)
                          }
                        />
                      </div>
                    </Form.Field>
                  </Form.Group>
                  <div className="contactLabel" style={{ margin: "0px" }}>
                    {translate(getLanguage(), "Availability for contact")}
                  </div>
                  <Form.Field
                    name="morning"
                    onChange={this.handleChange}
                    label={translate(getLanguage(), "Weekday mornings")}
                    control="input"
                    type="checkbox"
                  />
                  <Form.Field
                    name="afternoon"
                    onChange={this.handleChange}
                    label={translate(getLanguage(), "Weekday afternoons")}
                    control="input"
                    type="checkbox"
                  />
                  <div className="contactLabel" style={{ margin: "0px" }}>
                    {translate(getLanguage(), "Advertisement Creation")}
                  </div>
                  <Form.Field
                    onChange={() => this.needBanner(0)}
                    required
                    label={translate(getLanguage(), "I already have a banner")}
                    control="input"
                    type="radio"
                    name="htmlRadios"
                  />
                  <Form.Field
                    onChange={() => this.needBanner(1)}
                    required
                    label={translate(
                      getLanguage(),
                      "I would like a new banner, to be created"
                    )}
                    control="input"
                    type="radio"
                    name="htmlRadios"
                  />
                  <div className="contactLabel" style={{ margin: "0px" }}>
                    {translate(getLanguage(), "Notes")}
                  </div>
                  <Form.Field
                    name="notes"
                    onChange={this.handleChange}
                    label={translate(getLanguage(), "")}
                    control="textarea"
                    rows="3"
                  />

                  <Recaptcha
                    sitekey="6Lf0Zh8UAAAAALFj5VbOILRHcTQXl5yeAj5XzThO"
                    render="explicit"
                    verifyCallback={this.verifyCallback}
                    onloadCallback={this.callback}
                  />

                  <div className="contactInfo">
                    {translate(
                      getLanguage(),
                      "Contact us Telephone: +302119558800"
                    )}{" "}
                    <br></br>{" "}
                    {translate(getLanguage(), "Email: adv@openseas.gr")}
                  </div>

                  <Button
                    icon
                    labelPosition="right"
                    style={{ marginTop: "10px" }}
                    disabled={this.state.disabled}
                    type="submit"
                    onClick={() => this.showGDPRModal()}
                  >
                    {translate(getLanguage(), "Send Request")}
                    <Icon name="right arrow" style={{ padding: "0px" }} />
                  </Button>
                </Form>
              </div>
              <div className="OSPageSidebar">
                <Sidebar />
              </div>
            </div>
          </Row>
          <Row style={{ margin: "24px 0px 24px 0" }}>
            <div className="displayBannerLarge">
              <BannerRectangleLarge />
            </div>
          </Row>
          <Row>
            <Col xs={12} sm={6} mdHidden lgHidden>
              <BannerRectangle />
            </Col>
            <Col xsHidden sm={6} mdHidden lgHidden>
              <BannerRectangle />
            </Col>
          </Row>
          <Row style={{ margin: "0px" }}>
            <Footer />
          </Row>
        </Grid>
      </div>
    );
  }
}
export default Advertise;



// WEBPACK FOOTER //
// ./src/components/Pages/Advertise/Advertise.js